export const actions = {
  OPEN_CHAT: 'openChat',
  SET_VARIABLE: 'setVariable',
  DELETE_VARIABLE: 'deleteVariable',
  WEBHOOK: 'webhook',
};
